// libs
import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import { getBeds } from '../actions/bed/index';

// UI components
import Tabs from './UI/Tabs.js';
import Icon from '@material-ui/core/Icon';

// vars
import { VEGETABLE, CULINARY_HERB, FRUIT } from '../vars/types';
import { MAX_PLANT_VARIETY_LIMIT_PER_GARDEN } from '../vars/constants';

// styles
import '../css/customer-plant-select.css';

let CustomerPlantSelect = (props) => {
    const { plants, onChange } = props;
    const [currentSelection, setCurrentSelection] = useState(plants);
    const [plantCategory, setPlantCategory] = useState(VEGETABLE);
    const selected = currentSelection.filter((p) => p.selected);

    useEffect(() => {
        setCurrentSelection(plants);
    }, [plants]);

    const renderTabs = () => {
        const totalVegetablesSelected = currentSelection
            ? currentSelection.reduce((total, current) => {
                  if (
                      current.plant.primary.category.name === VEGETABLE &&
                      current.selected
                  ) {
                      return total + 1;
                  }
                  return total;
              }, 0)
            : 0;

        const totalHerbsSelected = currentSelection
            ? currentSelection.reduce((total, current) => {
                  if (
                      current.plant.primary.category.name === CULINARY_HERB &&
                      current.selected
                  ) {
                      return total + 1;
                  }
                  return total;
              }, 0)
            : 0;

        const totalFruitSelected = currentSelection
            ? currentSelection.reduce((total, current) => {
                  if (
                      current.plant.primary.category.name === FRUIT &&
                      current.selected
                  ) {
                      return total + 1;
                  }
                  return total;
              }, 0)
            : 0;

        const plantCategoryTabs = [
            {
                title: `Vegetables (${totalVegetablesSelected})`,
                icon: '',
                content: 'veggies',
                value: VEGETABLE,
            },
            {
                title: `Herbs (${totalHerbsSelected})`,
                icon: '',
                content: 'herbs',
                value: CULINARY_HERB,
            },
            {
                title: `Fruit (${totalFruitSelected})`,
                icon: '',
                content: 'fruit',
                value: FRUIT,
            },
        ];

        return (
            <div>
                <Tabs
                    className="plant-selection-tabs"
                    outlined={true}
                    data={plantCategoryTabs}
                    defaultValue={VEGETABLE}
                    onChange={(item) => {
                        const value = item.title.split(' ')[0];
                        if (value === 'Vegetables') {
                            setPlantCategory(VEGETABLE);
                        }
                        if (value === 'Fruit') {
                            setPlantCategory(FRUIT);
                        }
                        if (value === 'Herbs') {
                            setPlantCategory(CULINARY_HERB);
                        }
                    }}
                />
            </div>
        );
    };

    const validatePlantSelectionSize = (plants) => {
        return plants <= MAX_PLANT_VARIETY_LIMIT_PER_GARDEN;
    };

    const updatePlantSelection = (plant) => {
        let isMaxSizeLimit = false;
        let plantsToUpdate = [...currentSelection];
        plantsToUpdate.forEach((plantToUpdate) => {
            if (plantToUpdate.plant._id === plant._id) {
                if (plantToUpdate.selected) {
                    plantToUpdate.selected = false;
                } else {
                    if (validatePlantSelectionSize(selected.length + 1)) {
                        plantToUpdate.selected = true;
                    } else {
                        isMaxSizeLimit = true;
                    }
                }
            }
        });
        if (isMaxSizeLimit) {
            return window.alert('You have reached your plant selection limit');
        } else {
            setCurrentSelection(plantsToUpdate);
            onChange(plantsToUpdate);
        }
    };

    const renderGardenSizeLimitMessage = () => {
        return (
            <div className="limit-message">
                <p className="text-small" style={{ marginBottom: 0 }}>
                    * You can select up to {MAX_PLANT_VARIETY_LIMIT_PER_GARDEN}{' '}
                    plant varieties
                </p>
                <data className="text-small selection-indicator">
                    {selected.length}/{MAX_PLANT_VARIETY_LIMIT_PER_GARDEN}{' '}
                    selected
                </data>
            </div>
        );
    };

    const renderPlants = () => {
        const plantsInCategory = currentSelection.filter(
            (p) => p.plant.primary.category.name === plantCategory,
        );

        const list = plantsInCategory
            .sort((a, b) => a.plant.name.localeCompare(b.plant.name))
            .map((plantData, index) => {
                return (
                    <div
                        className={`card ${
                            plantData.selected ? 'checked' : ''
                        }`}
                        onClick={() => updatePlantSelection(plantData.plant)}
                        key={index}
                    >
                        <span
                            style={{
                                color: 'var(--purpleB)',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {plantData.selected ? (
                                <Icon>check</Icon>
                            ) : (
                                <Icon>crop_square</Icon>
                            )}
                        </span>

                        <div className="flex-center-y">
                            <img
                                style={{
                                    height: 'var(--unit5)',
                                    width: 'var(--unit5)',
                                }}
                                src={plantData.plant.image}
                                alt="plant"
                            />
                            &nbsp;
                            <p className="capitalize text-small m0">
                                {plantData.plant.name}
                            </p>
                        </div>
                    </div>
                );
            });

        return list;
    };

    return (
        <>
            <div className="flex-center">{renderTabs()}</div>
            {renderGardenSizeLimitMessage()}
            <div className="plant-selection-grid">{renderPlants()}</div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        user: state.user,
        beds: state.bed,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getBeds,
        },
        dispatch,
    );
}

CustomerPlantSelect = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CustomerPlantSelect);

export default CustomerPlantSelect;
